import {
  Activity,
  AlertCircle,
  Box,
  Check,
  Clock,
  Cpu,
  X,
  Zap,
} from 'lucide-react';

export const AGENT_TYPES_FILTER = [
  { value: 'all', label: 'TODOS_LOS_TIPOS', icon: Box },
  { value: 'autonomous', label: 'AUTÓNOMO', icon: Cpu },
  { value: 'scheduled', label: 'PROGRAMADO', icon: Clock },
  { value: 'reactive', label: 'REACTIVO', icon: Zap },
];

export const FORM_AGENT_TYPES = [
  { value: 'autonomous', label: 'AUTÓNOMO', icon: Cpu },
  { value: 'scheduled', label: 'PROGRAMADO', icon: Clock },
  { value: 'reactive', label: 'REACTIVO', icon: Zap },
];

export const AGENT_STATUSES_FILTER = [
  { value: 'all', label: 'TODOS_LOS_ESTADOS', icon: Activity },
  { value: 'online', label: 'ONLINE', icon: Check },
  { value: 'offline', label: 'OFFLINE', icon: X },
  { value: 'busy', label: 'OCUPADO', icon: Clock },
  { value: 'error', label: 'ERROR', icon: AlertCircle },
];

export const FORM_AGENT_STATUSES = [
  { value: 'online', label: 'ONLINE', icon: Check },
  { value: 'offline', label: 'OFFLINE', icon: X },
  { value: 'busy', label: 'OCUPADO', icon: Clock },
  { value: 'error', label: 'ERROR', icon: AlertCircle },
];
